"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _PhoneNumberInput = _interopRequireDefault(require("ui-addon-i18n/components/PhoneNumberInput"));

var _communicationMethodTypes = _interopRequireDefault(require("ui-addon-upgrades/_core/communicationMethods/communicationMethodTypes"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var _getSalesPhoneNumber2 = _interopRequireDefault(require("ui-addon-upgrades/_core/common/adapters/getSalesPhoneNumber"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _submitPql = require("ui-addon-upgrades/_core/pql/submitPql");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var PHONE_NUMBERS_URL = 'https://www.hubspot.com/company/contact';

var CommunicationSelectedMethodCall = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CommunicationSelectedMethodCall, _React$Component);

  function CommunicationSelectedMethodCall(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CommunicationSelectedMethodCall);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CommunicationSelectedMethodCall).call(this, props));
    _this.state = {
      phoneNumber: ''
    };
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInputChange = _this.handleInputChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CommunicationSelectedMethodCall, [{
    key: "handleSubmit",
    value: function handleSubmit() {
      var phoneNumber = this.state.phoneNumber;
      var upgradeData = this.props.upgradeData; // Don't send PQL if user doesn't provide number

      if (!phoneNumber) {
        return;
      }

      (0, _submitPql.submitPql)(upgradeData, {
        phoneNumber: phoneNumber
      });
      this.setState({
        isPhoneNumberSubmitted: true
      });
      tracker.track('communicationMethodsInteraction', Object.assign({
        action: 'submitted phone number'
      }, upgradeData));
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var setSelectedCommunicationMethod = this.props.setSelectedCommunicationMethod;
      setSelectedCommunicationMethod(_communicationMethodTypes.default.INITIAL);
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(_ref) {
      var phoneNumber = _ref.phoneNumber;
      this.setState({
        phoneNumber: phoneNumber
      });
    }
  }, {
    key: "renderSuccessCopy",
    value: function renderSuccessCopy() {
      var onDark = this.props.onDark;
      var linkUse = onDark ? 'on-dark' : 'dark';

      var _getSalesPhoneNumber = (0, _getSalesPhoneNumber2.default)(_I18n.default.lang, _I18n.default.locale),
          phoneNumber = _getSalesPhoneNumber.phoneNumber,
          countryCode = _getSalesPhoneNumber.countryCode;

      return _react.default.createElement("div", {
        className: "communication-call-submit-success"
      }, _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods.callSuccess"
      })), _react.default.createElement("h6", {
        className: "is--heading-6 uppercase"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods.localization.or"
      })), _react.default.createElement("span", null, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods.localization.callNow"
      })), _react.default.createElement("h4", {
        className: "is--heading-4 m-bottom-0"
      }, phoneNumber), _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: "SharedI18nStrings.countryCodes." + countryCode
      })), _react.default.createElement("p", {
        className: "m-top-8"
      }, _react.default.createElement(_UILink.default, {
        use: linkUse,
        href: PHONE_NUMBERS_URL,
        external: true
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods.localization.viewAllButton"
      }))));
    }
  }, {
    key: "renderPhoneNumberInput",
    value: function renderPhoneNumberInput() {
      var onDark = this.props.onDark;
      var buttonUse = onDark ? 'primary-white' : 'primary';
      var linkUse = onDark ? 'link-on-dark' : 'link';
      return _react.default.createElement("div", null, _react.default.createElement(_PhoneNumberInput.default, {
        className: "m-bottom-6",
        style: {
          width: 'auto'
        },
        value: this.state.phoneNumber,
        onChange: this.handleInputChange
      }), _react.default.createElement(_UIButton.default, {
        className: "communication-call-submit-button center-block m-bottom-4",
        onClick: this.handleSubmit,
        use: buttonUse
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods.callButton"
      })), _react.default.createElement(_UIButton.default, {
        className: "communication-call-back-button center-block",
        use: linkUse,
        onClick: this.handleClick
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods.backButton"
      })));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var isPhoneNumberSubmitted = this.state.isPhoneNumberSubmitted;

      if (isPhoneNumberSubmitted) {
        return this.renderSuccessCopy();
      }

      return this.renderPhoneNumberInput();
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "selected-method-call text-center",
        "data-test-id": "communication-selected-method-call"
      }, _react.default.createElement("h2", null, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods.callTitle"
      })), this.renderContent());
    }
  }]);
  return CommunicationSelectedMethodCall;
}(_react.default.Component);

CommunicationSelectedMethodCall.defaultProps = {
  setSelectedCommunicationMethod: _emptyFunction.default
};
CommunicationSelectedMethodCall.propTypes = Object.assign({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, {
  setSelectedCommunicationMethod: _propTypes.default.func.isRequired
});
var _default = CommunicationSelectedMethodCall;
exports.default = _default;
module.exports = exports.default;